module.exports = __webpack_public_path__ + "media/images/plans/proposal-schedule_4-1-e4a52c8a94cadccce5695dad34456f9a.jpg";